




















import InputField from "./InputField";

export default {
    name: "RadioButtons",
    components: { InputField },
    props: {
        label: String,
        value: Number | String,
        options: Object,
    },
    data() {
        return {
            selected: null,
            optionsArray: [],
        };
    },
    created() {},
    watch: {
        selected: function () {
            if (this.selected) {
                this.$emit("input", this.selected.id);
            }
        },
        options: {
            immediate: true,
            handler: function () {
                this.optionsArray = _.toArray(this.options);
                this.selected = _.find(this.optionsArray, { id: this.value });
            },
        },
        value: {
            immediate: true,
            handler: function () {
                this.selected = _.find(this.optionsArray, { id: this.value });
            },
        },
    },
};
